"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _NavigateBackButton = require("@ccw-pwa-ui/NavigateBackButton");
var _react = _interopRequireDefault(require("react"));
var _ConnectionLoader = require("@ccw-pwa-ui/ConnectionLoader");
var _Modal = require("@ccw-pwa-ui/Modal");
var _Input = require("@ccw-pwa-ui/Input");
require("../styles/EditSensorComponent.css");
var _Button = require("@ccw-pwa-ui/Button");
var _images = _interopRequireDefault(require("../common_features/assets/images"));
//import { HeaderText } from "@ccw-pwa-ui/HeaderText"

const EditSensorComponent = _ref => {
  let {
    handleBack,
    leftArrow,
    editSensorText,
    backNavigationScreen,
    subText,
    installationDateText,
    installationDate,
    sensorImage,
    serialNumberText,
    serialNumber,
    moveSensorButtonText,
    onClickMoveSensor,
    removeSensorButtonText,
    onClickRemoveSensor,
    warningModal,
    warningSensorModalData,
    socketLoader,
    openErrorModal,
    pname,
    removeSensorButtonDisable
  } = _ref;
  return socketLoader ? /*#__PURE__*/_react.default.createElement(_ConnectionLoader.ConnectionLoader, null) : /*#__PURE__*/_react.default.createElement("div", {
    className: "edit-sensor-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_NavigateBackButton.NavigateBackButton, {
    navHeading: backNavigationScreen,
    handleBack: handleBack,
    leftArrowImage: _images.default.leftArrow.default
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "edit-sensor-body"
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: "edit-sensor-text-wrapper"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "edit-sensorr-text"
  }, editSensorText)), pname && /*#__PURE__*/_react.default.createElement("div", {
    className: "edit-sensor-pname"
  }, pname), /*#__PURE__*/_react.default.createElement("div", {
    className: "sub-text-wrapper"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "sub-text"
  }, subText))), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: "edit-sensor-text-wrapper"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "installation-date-text"
  }, installationDateText)), /*#__PURE__*/_react.default.createElement("div", {
    className: "date-input-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_Input.Input, {
    disabled: true,
    inputStyle: {
      borderRadius: 10
    },
    placeholder: installationDateText,
    value: installationDate
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "image-wrapper"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: sensorImage
  })), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: "edit-sensor-text-wrapper"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "installation-date-text"
  }, serialNumberText)), /*#__PURE__*/_react.default.createElement("div", {
    className: "date-input-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_Input.Input, {
    disabled: true,
    inputStyle: {
      borderRadius: 10
    },
    placeholder: serialNumberText,
    value: serialNumber
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "move-remove-wrapper"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "move-sensor-button"
  }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    variant: "outline-primary-long",
    title: moveSensorButtonText,
    onClick: onClickMoveSensor
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "remove-sensor-button"
  }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    variant: "outline-primary-long",
    title: removeSensorButtonText,
    onClick: onClickRemoveSensor,
    disabled: removeSensorButtonDisable
  })))), (warningModal || openErrorModal) && /*#__PURE__*/_react.default.createElement("div", {
    className: ""
  }, /*#__PURE__*/_react.default.createElement(_Modal.Modal, {
    displayModal: warningSensorModalData === null || warningSensorModalData === void 0 ? void 0 : warningSensorModalData.displayModal,
    modalHeaderText: warningSensorModalData === null || warningSensorModalData === void 0 ? void 0 : warningSensorModalData.modalHeaderText,
    modalHeaderTextStyle: warningSensorModalData === null || warningSensorModalData === void 0 ? void 0 : warningSensorModalData.modalHeaderTextStyle,
    modalDetailText: warningSensorModalData === null || warningSensorModalData === void 0 ? void 0 : warningSensorModalData.modalDetailText,
    modalHeaderIcon: warningSensorModalData === null || warningSensorModalData === void 0 ? void 0 : warningSensorModalData.modalHeaderIcon,
    displayCrossIcon: warningSensorModalData === null || warningSensorModalData === void 0 ? void 0 : warningSensorModalData.displayCrossIcon,
    variant: warningSensorModalData === null || warningSensorModalData === void 0 ? void 0 : warningSensorModalData.variant,
    positiveActionButtonTitle: warningSensorModalData === null || warningSensorModalData === void 0 ? void 0 : warningSensorModalData.positiveActionButtonTitle,
    positiveAction: warningSensorModalData === null || warningSensorModalData === void 0 ? void 0 : warningSensorModalData.positiveAction,
    negativeButtonActionTitle: warningSensorModalData === null || warningSensorModalData === void 0 ? void 0 : warningSensorModalData.negativeButtonActionTitle,
    crossIconAction: warningSensorModalData === null || warningSensorModalData === void 0 ? void 0 : warningSensorModalData.crossIconAction,
    negativeAvtion: warningSensorModalData === null || warningSensorModalData === void 0 ? void 0 : warningSensorModalData.negativeAvtion
  })));
};
var _default = exports.default = EditSensorComponent;